<template>
  <div v-if="isPresent(challenge)" :class="isTiered ? '' : 'p-6 bg-white'">
    <TieredChallenge
      v-if="isTiered"
      :challenge="challenge"
      :performance="performance"
      :store-options="storeOptions"
      :selected-store-id="selectedStoreId"
      :has-multiple-stores="hasMultipleStores"
      @store-change="$emit('store-change', $event)"
    />
    <PointsChallenge
      v-else
      :challenge="challenge"
      :sellers="performance.sellers"
      :stores="performance.stores"
      :organizationSellers="performance.organizationSellers"
      :matchedContracts="performance.matchedContracts"
      :storePerformance="performance.storePerformance"
      :selectedStore="performance.selectedStore"
    />
  </div>
</template>

<script>
import { isPresent } from "@estaly/ui";

import PointsChallenge from "@/components/challenge/PointsChallenge.vue";
import TieredChallenge from "@/components/challenge/TieredChallenge.vue";
import { isTieredChallenge } from "@/utils/challengeTiers";

export default {
  components: { PointsChallenge, TieredChallenge },

  props: ["challenge", "performance", "storeOptions", "selectedStoreId", "hasMultipleStores"],

  emits: ["store-change"],

  computed: {
    isTiered() {
      return isTieredChallenge(this.challenge);
    },
  },

  methods: {
    isPresent,
  },
};
</script>
